<p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadData($event)" [loading]="loading"
    [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of displayedColumns" >
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
        <tr>
            <td *ngFor="let col of displayedColumns">
                <ng-container [ngSwitch]="col.type">

                    <ng-container *ngSwitchCase="'contact_name'">
                        {{ getFullName(rowData)}}
                    </ng-container>

                    <ng-container *ngSwitchCase="'actions'">
                        <button 
                            pButton 
                            type="button" 
                            icon="pi pi-trash" 
                            class="p-button-rounded p-button-danger p-button-text"
                            (click)="deleteContact(rowData)"
                            pTooltip="Delete contact from group"
                            tooltipPosition="top">
                        </button>
                    </ng-container>
                   
                    <!-- Default Case (Normal Field) -->
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loading">
        <tr>
            <td colspan="3" class="text-center">
                <p-progressSpinner></p-progressSpinner>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                <p>No records found</p>
            </td>
        </tr>
    </ng-template>
</p-table>

<!-- Delete Confirmation Dialog -->
<p-dialog [modal]="true" [visible]="openDeleteDialog" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    [closable]="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <div class="flex items-center justify-center dialog-header">
        Delete Contact
        <div class="absolute right-2">
            <button (click)="closeDeleteDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <div class="text-center">
            <p>
                Are you sure you want to delete this contact from the group?
            </p>
        </div>
        <div class="flex justify-end mt-4">
            <p-button
                label="Delete"
                icon="pi pi-trash"
                severity="danger"
                [loading]="deleteLoading"
                class="flex justify-end"
                (click)="confirmDelete()">
            </p-button>
        </div>
    </div>
</p-dialog>